/**
 * Formats a batch name by capitalizing each word and handling special cases
 * @param batch - The batch name to format (e.g. "EXPEDITION_NAME_2024")
 * @returns Formatted batch name (e.g. "Expedition Name 2024")
 */
export function formatBatchName(batch: string): string {
  if (!batch) return ''
  
  const parts = batch.split('_')
  return parts
    .map(part => {
      // Handle empty parts
      if (!part) return ''
      // Special case for common words
      if (part.toLowerCase() === 'expedition') return 'Expedition'
      // Capitalize first letter, lowercase rest
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
    })
    .filter(Boolean) // Remove empty parts
    .join(' ')
} 